import { Box, Typography } from '@mui/material'
import { FC } from 'react'

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { usePolicyStore } from 'Application/store';
import Loader from 'ui-component/Loader';

interface VerifyDocumentPageProps {}

export const VerifyDocumentPage: FC<VerifyDocumentPageProps> = () => {

  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const policyNumber = query.get('policyNumber');

  const { checkPolicyValidity, isPolicyDocumentValid } = usePolicyStore((state) => ({
    checkPolicyValidity: state.checkPolicyValidity,
    isPolicyDocumentValid: state.isPolicyDocumentValid
  }));

  useEffect(() => {
    const validateDocument = async () => {
      if (!policyNumber) {
        toast.error('No policy number provided');
        return;
      }

      try {
        const response = await checkPolicyValidity(policyNumber);

        if(response === true){
          toast.success('Policy document is valid');
        }else{
          toast.error('Policy document is invalid');
        }

      } catch (err) {
        toast.error('Failed to validate policydocument');
      }
    };

    validateDocument();
  }, [policyNumber]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        padding: '2rem',
      }}
    >
      {isPolicyDocumentValid === null ? (
        <Loader />
      ) : (
        <Box
          sx={{
            backgroundColor: 'white',
            borderRadius: '15px',
            padding: '2rem',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            textAlign: 'center',
            maxWidth: '400px',
            width: '100%',
          }}
        >
          <Typography variant="h4" gutterBottom sx={{ color: '#333', fontWeight: 'bold', marginBottom: '1.5rem' }}>
            Policy Verification
          </Typography>
          <Box
            sx={{
              backgroundColor: '#f0f0f0',
              borderRadius: '10px',
              padding: '1rem',
              marginBottom: '1rem',
            }}
          >
            <Typography variant="subtitle1" sx={{ color: '#666' }}>
              Policy Number:
            </Typography>
            <Typography variant="h6" sx={{ color: '#333', fontWeight: 'bold' }}>
              {policyNumber}
            </Typography>
          </Box>
          <Typography
            variant="h5"
            sx={{
              color: isPolicyDocumentValid ? 'green' : 'red',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {isPolicyDocumentValid ? (
              <>
                <span style={{ marginRight: '0.5rem' }}>✅</span> Valid
              </>
            ) : (
              <>
                <span style={{ marginRight: '0.5rem' }}>❌</span> Invalid
              </>
            )}
          </Typography>
        </Box>
      )}
    </Box>
  )
}